import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BodyType } from '../api/types';

const useBodyTypeFilter = () => {
    const { t } = useTranslation('common');

    return useMemo(() => {
        const bodyTypeFilterItems = [
            {
                text: t('common:options.bodyTypes.coupe'),
                value: BodyType.Coupe,
            },
            {
                text: t('common:options.bodyTypes.convertible'),
                value: BodyType.Convertible,
            },
            {
                text: t('common:options.bodyTypes.hatchback'),
                value: BodyType.Hatchback,
            },
            {
                text: t('common:options.bodyTypes.mpv'),
                value: BodyType.Mpv,
            },
            {
                text: t('common:options.bodyTypes.sedan'),
                value: BodyType.Sedan,
            },
            {
                text: t('common:options.bodyTypes.suv'),
                value: BodyType.Suv,
            },
            {
                text: t('common:options.bodyTypes.van'),
                value: BodyType.Van,
            },
            {
                text: t('common:options.bodyTypes.wagon'),
                value: BodyType.Wagon,
            },
        ];

        return bodyTypeFilterItems;
    }, [t]);
};

export default useBodyTypeFilter;
